import { ModalProps } from 'react-native';
import { styles } from './ModalFullscreenContainer.styles';
import Animated, { FadeIn, FadeOut } from 'react-native-reanimated';

export const ModalFullscreenContainer = ({ testID, children, visible, animationType }: ModalProps) => {
  return (
    <Animated.View
      testID={testID}
      entering={animationType === 'fade' ? FadeIn.duration(1000) : undefined}
      exiting={animationType === 'fade' ? FadeOut.duration(1000) : undefined}
      style={[styles.container, !visible && styles.hidden]}
    >
      {children}
    </Animated.View>
  );
};
